import { useCreateApp } from '../shell';
import { Icon } from './Icon';

// Shown in the content area when the account has no applications yet — a fresh
// account or after deleting the last app. Offers to create the first application.
export function EmptyApps() {
  const createApp = useCreateApp();

  const addApp = () => {
    const name = window.prompt('Nazwa pierwszej aplikacji:');
    if (name?.trim()) createApp.mutate({ name: name.trim() });
  };

  return (
    <div className="view">
      <div className="card empty-state">
        <div className="empty-title">Nie masz jeszcze żadnej aplikacji</div>
        <p>Utwórz pierwszą aplikację, aby zacząć dodawać research, leady i pipeline.</p>
        <button className="btn primary big" disabled={createApp.isPending} onClick={addApp}>
          <Icon name="plus" size={15} /> {createApp.isPending ? 'Tworzę…' : 'Utwórz aplikację'}
        </button>
      </div>
    </div>
  );
}
